import { isDevBuild } from '../../functions';

interface Props {
  children?: React.ReactNode;
}

export const DevOnly = (props: Props) =>
  isDevBuild() && props.children ? <>{props.children}</> : null;
